<div class="outpost-container">
  <div class="menu">
    <ichannel-link [name]="'LICENSE'" [link]="'license'"></ichannel-link>
    <ichannel-link [name]="'REMOTE'" [link]="'remote'"></ichannel-link>
    <ichannel-link [name]="'FILES'" [link]="'files'"></ichannel-link>
    <ichannel-link [name]="'ALERTS'" [link]="'alerts'"></ichannel-link>
  </div>
  <router-outlet></router-outlet>
</div>
